import { motion } from 'framer-motion';

interface GuestSelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const GuestSelector = ({ value, onChange, disabled }: GuestSelectorProps) => {
  const guestOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9+', label: '9+' },
  ];

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {guestOptions.map(option => (
          <motion.button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            disabled={disabled}
            whileHover={{ scale: disabled ? 1 : 1.05 }}
            whileTap={{ scale: disabled ? 1 : 0.95 }}
            className={`min-w-[44px] h-11 px-4 rounded-full border-2 font-medium transition-all duration-200 ${
              value === option.value
                ? 'bg-red-800 border-red-800 text-white shadow-md'
                : 'bg-white border-neutral-300 text-neutral-700 hover:border-red-300 hover:bg-red-50'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          >
            {option.label}
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default GuestSelector;
